import React, { useState, useEffect } from "react";
import { Row } from "react-bootstrap";
import { CCol, CFormLabel, CFormFeedback, CFormInput } from "@coreui/react";
import { ToastContainer } from "react-toastify";
import { useDispatch } from "react-redux";
import { getCustomerData, getCustomerDetail, deleteCustomer } from "../../../redux/slices/CustomerSlice";
import { toastMessage } from "../../../helpers/utility.js";
import PageWrapper from "../../../pagecomponents/Common/PageWrapper.js";
import DataTable from "../../../pagecomponents/Common/DataTable.js";
import Swal from "sweetalert2";
import ModalWrapper from "../../../pagecomponents/Common/ModalWrapper.js";
import CustomerAddEdit from "./AddEditForm.js";
import useDebouncedValue from "../../../helpers/useDebouncedValue.js";


const CustomerIndex = () => {
    const dispatch = useDispatch();
    let pageName = "Customer";
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalPage, setTotalPage] = useState(0);

    const LIST_PARAMS = {
        skip: 0,
        take: rowsPerPage,
        sorting: 'asc',
        sorting_key: 'created_at',
        filter: {
            customer_Code: "",
            customer_Name: "",
            customer_Registration_No: "",
            customer_Mobile: "",
        }
    };
    
    const [data, setData] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [params, setParams] = useState(LIST_PARAMS);
    const [textFilters, setTextFilters] = useState({
        customer_Code: "",
        customer_Name: "",
        customer_Registration_No: "",
        customer_Mobile: "",
    });
    const debouncedTextFilters = useDebouncedValue(textFilters, 400);
    const [isEdit, setIsEdit] = useState(false);
    const [filterSectionVisible, setFilterSectionVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [deleteParam, setDeleteParam] = useState({
        "customer_Id" : 0,
        "type" : 'delete',
    });

    const [editData, setEditData] = useState([]);


    

    useEffect(()=> {
        getCustomerList();
    }, [params]);

    useEffect(() => {
        setCurrentPage(1);
        setParams((prev) => {
            const prevFilter = prev?.filter || {};
            const isSameFilter =
                String(prevFilter.customer_Code || "") === debouncedTextFilters.customer_Code &&
                String(prevFilter.customer_Name || "") === debouncedTextFilters.customer_Name &&
                String(prevFilter.customer_Registration_No || "") === debouncedTextFilters.customer_Registration_No &&
                String(prevFilter.customer_Mobile || "") === debouncedTextFilters.customer_Mobile;

            if (isSameFilter && prev.skip === 0) {
                return prev;
            }

            return {
                ...prev,
                skip: 0,
                filter: {
                    ...prevFilter,
                    ...debouncedTextFilters,
                },
            };
        });
    }, [debouncedTextFilters]);
    
    const getCustomerList = async() => {
        setIsLoading(true);

        try {
            const { payload } = await dispatch(getCustomerData({ inputData: params }));
            setData(payload?.data);
            setTotalPage(Math.ceil(payload?.count/rowsPerPage)); 
        } catch (err) {
            toastMessage("error", "Failed to fetch data");
        } finally {
            setIsLoading(false); // Stop loader
        }
    };
    
    const deleteData = async(updatedFormData) => {
        const { payload } = await dispatch(deleteCustomer({ inputData: updatedFormData }));
        if (payload?.status === "error") {
            toastMessage("error", payload.msg || "An error occurred while saving.");
        } else {
            Swal.fire("Deleted!", "Your file has been deleted.", "success");
            getCustomerList();
        }
    };
    
    const openAddModal = () => {
        setModalVisible(true);
        setIsEdit(false);
    };

    const openEditModal = async (item) => {
        setIsEdit(true);
        const detailAction = await dispatch(getCustomerDetail({ inputData: { customer_Id: item.customer_Id } }));
        setEditData(detailAction?.payload?.data?.[0] || item);
        setModalVisible(true);
    };

    const handleDelete = (item) => {
        const updatedFormData = { ...deleteParam, customer_Id: item.customer_Id };
        deleteData(updatedFormData);
    };

    const closeModal = () => {
        setModalVisible(false);
    };

    // const handleSort = (key) => {
    //     setParams((prev) => ({
    //         ...prev,
    //         sorting: prev.sorting_key === key && prev.sorting === "asc" ? "desc" : "asc",
    //         sorting_key: key,
    //     }));
    // };

    const handleSort = (key) => {
        setCurrentPage(1);
        
        setParams((prev) => ({
            ...prev,
            skip: 0,
            sorting_key: key,
            sorting: prev.sorting_key === key && prev.sorting === "asc" ? "desc" : "asc",
        }));
    };

    const handleRowsPerPageChange = (rows) => {
        setRowsPerPage(rows);
        setCurrentPage(1);
        
        setParams((prev) => ({
          ...prev,
          take: rows,
          skip: 0,
        }));
    };

    const setPage = (pagenum) => {
        setCurrentPage(pagenum);
        setParams((prev) => ({
            ...prev,
            skip: (pagenum - 1) * prev.take,
        }));
    };

    // Define table columns
    const columns = [
        { label: "Code", accessor: "customer_Code", sortable: true },
        { label: "Name", accessor: "customer_Name", sortable: true },
        { label: "Mobile", accessor: "customer_Mobile", sortable: true },
        { label: "Reg. No", accessor: "customer_Registration_No", sortable: true },
        { label: "Op Balance", accessor: "ledger_Opening_Balance", sortable: true },
        { label: "Type", accessor: "ledger_type", sortable: true },
    ];

    const handleFilterParamsOnChange = (e) => {
        const {name, value} = e.target;
        setTextFilters((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const toogleFilterSection = () => {
        setFilterSectionVisible((prev) => !prev);
    };


    return(
        <>
            <ToastContainer />
            <PageWrapper 
                pageName={pageName}
                headerBtnTitle="+ Customer"
                onHeaderButtonClick={() => {openAddModal()}}
                showFilterBtn={true}
                onFilterBtnClick={() => toogleFilterSection()}
                filterBtnTitle={filterSectionVisible ? 'Hide Filter' : 'Show Filter'}
                showAddBtn={true}
            >
                {filterSectionVisible && (
                    <Row className="row-sm mb-3">
                        <CCol md={2}>
                            <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="customer_Code">Cust. Code</CFormLabel>
                            <CFormInput
                                type="text"
                                id="customer_Code"
                                name="customer_Code"
                                value={textFilters.customer_Code}
                                onChange={handleFilterParamsOnChange}
                                required
                            />
                            <CFormFeedback invalid>Code</CFormFeedback>
                        </CCol>
                        <CCol md={4}>
                            <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="customer_Name">Cust. Name</CFormLabel>
                            <CFormInput
                                type="text"
                                id="customer_Name"
                                name="customer_Name"
                                value={textFilters.customer_Name}
                                onChange={handleFilterParamsOnChange}
                                required
                            />
                            <CFormFeedback invalid>Code</CFormFeedback>
                        </CCol>
                        <CCol md={3}>
                            <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="customer_Registration_No">Reg. No</CFormLabel>
                            <CFormInput
                                type="text"
                                id="customer_Registration_No"
                                name="customer_Registration_No"
                                value={textFilters.customer_Registration_No}
                                onChange={handleFilterParamsOnChange}
                                required
                            />
                            <CFormFeedback invalid>Code</CFormFeedback>
                        </CCol>
                        <CCol md={3}>
                            <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="customer_Mobile">Mobile No</CFormLabel>
                            <CFormInput
                                type="text"
                                id="customer_Mobile"
                                name="customer_Mobile"
                                value={textFilters.customer_Mobile}
                                onChange={handleFilterParamsOnChange}
                                required
                            />
                            <CFormFeedback invalid>Code</CFormFeedback>
                        </CCol>
                        {/* <CCol md={2}>
                            <button type="button" className=" btn btn-dark" onClick={()=>{getCustomerList()}}>Filter</button>
                        </CCol> */}
                    </Row>
                )}

                <DataTable 
                    columns={columns} 
                    data={data} 
                    onEdit={openEditModal}
                    onDelete={handleDelete}
                    onSorting={handleSort}
                    sortingState={{ key: params.sorting_key, order: params.sorting }}
                    currentPage={currentPage}
                    totalPages={totalPage}
                    rowsPerPage={rowsPerPage}
                    updateRowsPerPage={handleRowsPerPageChange}
                    onPageChange={setPage}
                    loader={isLoading}
                />
            </PageWrapper>

            {/* Add/Edit Modal */}
            <ModalWrapper
                modalSize="lg"
                visible={modalVisible}
                onClose={closeModal}
                modalTitle={`${isEdit ? "Edit" : "Add"} ${pageName}`}
            >
                <CustomerAddEdit
                    reloadList={getCustomerList}
                    onSave={closeModal}
                    mode={isEdit}
                    data={editData}
                    section="Customer"
                />
            </ModalWrapper>
        </>
    );
};

export default CustomerIndex;
